export * as ar from 'air-datepicker/locale/ar';
export * as cs from 'air-datepicker/locale/cs';
export * as da from 'air-datepicker/locale/da';
export * as de from 'air-datepicker/locale/de';
export * as el from 'air-datepicker/locale/el';
export * as en from 'air-datepicker/locale/en';
export * as es from 'air-datepicker/locale/es';
export * as fi from 'air-datepicker/locale/fi';
export * as fr from 'air-datepicker/locale/fr';
export * as hu from 'air-datepicker/locale/hu';
export * as id from 'air-datepicker/locale/id';
export * as it from 'air-datepicker/locale/it';
export * as ja from 'air-datepicker/locale/ja';
export * as ko from 'air-datepicker/locale/ko';
export * as nl from 'air-datepicker/locale/nl';
export * as pl from 'air-datepicker/locale/pl';
export * as pt from 'air-datepicker/locale/pt';
// export * as ptBR from 'air-datepicker/locale/ptBR';
export * as ro from 'air-datepicker/locale/ro';
export * as ru from 'air-datepicker/locale/ru';
export * as si from 'air-datepicker/locale/si';
export * as sk from 'air-datepicker/locale/sk';
export * as sv from 'air-datepicker/locale/sv';
export * as th from 'air-datepicker/locale/th';
export * as tr from 'air-datepicker/locale/tr';
export * as uk from 'air-datepicker/locale/uk';
export * as zh from 'air-datepicker/locale/zh';
